<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col
          cols="12"
        >
        <h3 class="text-decoration-underline input-text-size">Transaction Configuration:</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size"
            v-model="editItem.usedLastBusinessDate"
            label="Enable Last Used Business Date"
          ></v-checkbox>
        </v-col>
        <v-col cols="3">
        <v-select
        class="input-text-size pa-0"
          label="Cash/ Check Deposit Bank"
          :items="bank"
          item-text="bankAltKey"
          item-value="_id"
          v-model="editItem.cashAndCheckDepositBank"
        ></v-select>
      </v-col>
      <v-col cols="3">
        <v-select
         class="input-text-size pa-0"
          label="CC Deposit bank"
          :items="bank"
          item-text="bankAltKey"
          item-value="_id"
          v-model="editItem.creditCardDepositBank"
        ></v-select>
      </v-col>
      <v-col cols="3" class="pt-0 pb-0 mt-n0">
      <v-row>
       <v-col cols="4">
       <label class="input-text-size font-weight-light">
         Default Wkst#:</label>
        </v-col>
        <v-text-field class="input-text-size pa-0" v-model="editItem.defaultWkstNo" />
        </v-row>
      </v-col>
      </v-row>
      <v-row>
      <v-col cols="3">
          <v-text-field
            v-model.number="editItem.durationOfCorrection"
            class="input-text-size pa-0"
            label="Duration of Correction(in Days)"
            type="number"
            ref="miscConfigDurationOfCorrection"
            v-if="isAdminUser"
            :rules="durationValidation"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-checkbox
           class="input-text-size radio-and-checekbox-size"
            v-model="editItem.defaultSpecialApportionment"
            label="Default To Special"
          ></v-checkbox>
        </v-col>
        <v-col cols="3">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size"
            v-model="editItem.requireBankAltKey"
            label="Require Bank Alt Key"
          ></v-checkbox>
        </v-col>
        <v-col cols="3">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size"
            v-model="editItem.editWkst"
            label="Enable edit of workstation number"
          ></v-checkbox>
        </v-col>
        </v-row>
        <v-row>
        <v-col cols="3" md="4">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size"
            v-model="editItem.enableAutofillofPaidByfromReceivedOf"
            label="Enable Autofill of Paid By from Received Of"
          ></v-checkbox>
        </v-col>
        <v-col cols="3" md="4">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size"
            v-model="editItem.isSeparateCashBankDepositEntries"
            label="Seperate Cash Bank Deposit Entries"
          ></v-checkbox>
        </v-col>
        <v-col cols="3" md="4">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size"
            v-model="editItem.isIndividualEFTDepositEntriesOnGl"
            label="Individual EFT Deposit Entries on GL"
          ></v-checkbox>
        </v-col>
        <v-col cols="3" md="4">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size"
            v-model="editItem.noAuditRecordOnVoids"
            label="No Audit Record on Voids"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size"
            v-model="editItem.ignoreOutOfBalanceReceipts"
            label="Ignore out of balance receipts"/>
        </v-col>
        <v-col cols="3">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size"
            v-model="editItem.enableExciseNamesAndTitlesOnEonForm"
            label="Enable Excise names and Titles on EON Form"/>
        </v-col>
        <v-col cols="3">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size"
            v-model="editItem.enableCommissionerNamesAndTitlesOnEonForm"
            label="Enable Commissioner names and Titles on EON Form"/>
        </v-col>
        <v-col cols="3">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size"
            v-model="editItem.misReceiptFromGl"
            label="Do not send to GL "/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-checkbox
            class="tmc-global-tax-unit-setting input-text-size "
            v-model="editItem.useNewUnitCodeSetup"
            label="Use New Setup for UnitCode"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
        <h3 class="text-decoration-underline input-text-size">Print Settings:</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" md="3">
          <v-text-field
            v-model.number="editItem.numberOfCopies"
            class="input-text-size pa-0"
            label="Number of Copies"
            type="number"
            :rules="numberOfCopiesValidation"
          ></v-text-field>
        </v-col>
        <v-col cols="3" md="3">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size"
            v-model.number="editItem.PrintCashCheckOtherAmount"
            label="Print Cash/Check/Other Amount"
          ></v-checkbox>
        </v-col>
        <v-col cols="3" md="3">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size"
            v-model="editItem.displaybankname"
            label="Display Bank Name on EFT/Other Payment"
          ></v-checkbox>
        </v-col>
        <v-col cols="3" md="3">
          <v-checkbox
            class="input-text-size radio-and-checekbox-size"
            v-model.number="editItem.printBankAccountNumber"
            label="Print Bank Account Number in Misc Receipt"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2" md="3">
          <v-text-field
          class="input-text-size pa-0"
          label="Tax Year"
          v-model.number="editItem.taxYear"
          type="number"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-radio-group
            v-model="editItem.printEONReportBoardCounty"
            row
            mandatory
          >
            <template v-slot:label>
              <div  class="input-text-size" ><h4>Print EON Report: </h4></div>
            </template>
            <v-radio
              class="input-text-size  radio-and-checekbox-size"
              label="Excise Board County"
              value="excise"
            ></v-radio>
            <v-radio
              class="input-text-size  radio-and-checekbox-size"
              label="Budget Board County"
              value="budget"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
        <h3 class="text-decoration-underline input-text-size">
          Default Option For Transaction Payment Type:</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-select
            v-model="editItem.eftPaymentType"
            class="input-text-size"
            label="Default Option For EFT Payment Type"
            :items="cmnEFTTypes"
            item-text="description"
            item-value="name"
          ></v-select>
        </v-col>
        <v-col cols="3">
          <v-select
            v-model="editItem.ccPaymentType"
            class="input-text-size"
            label="Default Option For CC Payment Type"
            :items="cmnCardTypes"
            item-text="description"
            item-value="name"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
        <h3 class="text-decoration-underline input-text-size">Forte Configuration:</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="editItem.apiAccessId"
            class="input-text-size"
            label="Forte API Access ID"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="editItem.apiSecureId"
            class="input-text-size"
            label="Forte API Secure Key"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="editItem.forteLocationId"
            class="input-text-size"
            label="Forte Location ID"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
        <h3 class="text-decoration-underline input-text-size">Payrix Configuration:</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="editItem.payrixMerchantId"
            class="input-text-size"
            label="Payrix Merchant ID"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="editItem.payrixEntityId"
            class="input-text-size"
            label="Payrix Entity ID"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
        <h3 class="text-decoration-underline input-text-size">
          Daily CR Export Configuration (For both Misc & Mtg):
        </h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field
            v-model="editItem.dailyCrOverrideWkst"
            class="input-text-size"
            label="Override Wkst on Daily CR Export"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          id="miscSettingSaveBtn"
          large
          color="primary"
          @click="update"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { isAuthorised } from '../../store/auth/token';
import { cloneItem } from '../../util/shared/vue-global';
import '../../assets/style.css';

const bankCrudKey = 'sharedBank';
const defaultPrintEONReportBoardCounty = 'excise';

export default {
  data: () => ({
    originalMiscSetting: null,
  }),
  computed: {
    ...mapState({
      editItem: (state) => {
        const settings = { ...state.SystemConfig.miscSettingItem || {} };
        settings.numberOfCopies = settings.numberOfCopies || 2;
        settings.printEONReportBoardCounty = settings.printEONReportBoardCounty
          || defaultPrintEONReportBoardCounty;
        return settings;
      },
      cmnEFTTypes: (state) => state.enums.MISCEFTTypeEnum || [],
      cmnCardTypes: (state) => state.enums.MISCCardTypeEnum || [],
    }),
    ...mapGetters('base/crud', [
      'items',
    ]),
    numberOfCopiesValidation() {
      return [
        (value) => {
          if (value === '' || value === undefined) {
            return true;
          }
          if (parseFloat(value) < 1) {
            return 'Invalid number of copies!';
          }
          return true;
        },
      ];
    },
    bank() {
      const bankObjs = this.items(bankCrudKey) || [];
      const updatedBankObjs = bankObjs.map((b) => ({
        ...b,
        bankAltKey: ` ${b.altKeyBase || ''} - ${b.bankName}`,
      }));
      return [{ _id: null, bankAltKey: '', bankName: '' }, ...updatedBankObjs];
    },
    durationValidation() {
      return [
        (value) => {
          if (value === '' || value === undefined) {
            return true;
          }
          if (parseFloat(value) <= 1) {
            return 'Invalid correction day!';
          }
          return true;
        },
      ];
    },
    isAdminUser() {
      // Text field's visibility won't change if user logs in and logs out in Misc settings.
      return isAuthorised(['MiscAdministration']);
    },
  },
  async created() {
    await this.loadConfig({ requiredScope: 'miscConfig' });
    this.originalMiscSetting = cloneItem(this.buildMiscConfigItem());
    this.loadBanks({
      criteria: {
        notEmptyAltKey: true,
        limit: 0,
      },
      baseCrudKey: bankCrudKey,
    });
  },
  methods: {
    buildMiscConfigItem() {
      const settingItem = this.editItem;
      /* When you will update any new field in the misc setting,
        you need to add the field here. */
      return {
        id: settingItem.id,
        payrixMerchantId: settingItem.payrixMerchantId,
        payrixEntityId: settingItem.payrixEntityId,
        usedLastBusinessDate: settingItem.usedLastBusinessDate,
        cashAndCheckDepositBank: settingItem.cashAndCheckDepositBank,
        creditCardDepositBank: settingItem.creditCardDepositBank,
        defaultWkstNo: settingItem.defaultWkstNo,
        durationOfCorrection: settingItem.durationOfCorrection,
        defaultSpecialApportionment: settingItem.defaultSpecialApportionment,
        requireBankAltKey: settingItem.requireBankAltKey,
        editWkst: settingItem.editWkst,
        enableAutofillofPaidByfromReceivedOf: settingItem.enableAutofillofPaidByfromReceivedOf,
        isSeparateCashBankDepositEntries: settingItem.isSeparateCashBankDepositEntries,
        isIndividualEFTDepositEntriesOnGl: settingItem.isIndividualEFTDepositEntriesOnGl,
        enableExciseNamesAndTitlesOnEonForm: settingItem.enableExciseNamesAndTitlesOnEonForm,
        enableCommissionerNamesAndTitlesOnEonForm: settingItem.enableCommissionerNamesAndTitlesOnEonForm,
        misReceiptFromGl: settingItem.misReceiptFromGl,
        useNewUnitCodeSetup: settingItem.useNewUnitCodeSetup,
        numberOfCopies: settingItem.numberOfCopies,
        PrintCashCheckOtherAmount: settingItem.PrintCashCheckOtherAmount,
        displaybankname: settingItem.displaybankname,
        printBankAccountNumber: settingItem.printBankAccountNumber,
        taxYear: settingItem.taxYear,
        printEONReportBoardCounty: settingItem.printEONReportBoardCounty,
        eftPaymentType: settingItem.eftPaymentType,
        ccPaymentType: settingItem.ccPaymentType,
        apiAccessId: settingItem.apiAccessId,
        apiSecureId: settingItem.apiSecureId,
        forteLocationId: settingItem.forteLocationId,
        dailyCrOverrideWkst: settingItem.dailyCrOverrideWkst,
        ignoreOutOfBalanceReceipts: settingItem.ignoreOutOfBalanceReceipts,
        noAuditRecordOnVoids: settingItem.noAuditRecordOnVoids,
      };
    },
    async update() {
      const result = this.$refs.miscConfigDurationOfCorrection.validate();
      if (result && window.confirm('Are you sure want to update this configuration?')) {
        const payload = {
          calledScope: 'miscConfig',
          item: this.buildMiscConfigItem(),
          previousItem: this.originalMiscSetting,
          isLogAudit: true,
        };
        const ok = await this.$store.dispatch('SystemConfig/updateConfig', payload);
        if (ok) {
          this.originalMiscSetting = cloneItem(this.buildMiscConfigItem());
        }
      }
    },
    ...mapActions('shared/bank', [
      'loadBanks',
    ]),
    ...mapActions('SystemConfig', [
      'loadConfig',
    ]),
  },
};
</script>
